export default {
  mounted() {
    this.el.addEventListener("dragstart", e => {
      const item = e.target.closest("[data-drag-type]")
      if (!item) return
      const data = {
        type: item.dataset.dragType,
        pos: item.dataset.dragPos,
        idx: item.dataset.dragIdx,
        playerId: item.dataset.dragPlayerId,
        pickId: item.dataset.dragPickId,
      }
      e.dataTransfer.setData("text/plain", JSON.stringify(data))
      e.dataTransfer.effectAllowed = "move"
      item.classList.add("opacity-40")
      this._dragging = item
    })

    this.el.addEventListener("dragend", e => {
      if (this._dragging) {
        this._dragging.classList.remove("opacity-40")
        this._dragging = null
      }
      this.el.querySelectorAll(".depth-drop-active").forEach(el =>
        el.classList.remove("depth-drop-active")
      )
    })

    this.el.addEventListener("dragover", e => {
      const target = e.target.closest("[data-drop-pos]")
      if (!target) return
      e.preventDefault()
      e.dataTransfer.dropEffect = "move"
      if (!target.classList.contains("depth-drop-active")) {
        this.el.querySelectorAll(".depth-drop-active").forEach(el =>
          el.classList.remove("depth-drop-active")
        )
        target.classList.add("depth-drop-active")
      }
    })

    this.el.addEventListener("dragleave", e => {
      const target = e.target.closest("[data-drop-pos]")
      if (target && !target.contains(e.relatedTarget)) {
        target.classList.remove("depth-drop-active")
      }
    })

    this.el.addEventListener("drop", e => {
      e.preventDefault()
      const target = e.target.closest("[data-drop-pos]")
      if (!target) return
      target.classList.remove("depth-drop-active")

      let data
      try { data = JSON.parse(e.dataTransfer.getData("text/plain")) } catch(_) { return }

      const toPos = target.dataset.dropPos
      const toIdx = target.dataset.dropIdx

      if (data.type === "slot") {
        if (data.pos === toPos && data.idx === toIdx) return
        this.pushEventTo(this.el, "depth_chart_move_slot", {
          from_pos: data.pos, from_idx: data.idx,
          to_pos: toPos, to_idx: toIdx,
        })
      } else if (data.type === "roster_player") {
        this.pushEventTo(this.el, "depth_chart_place_player", {
          pos: toPos, idx: toIdx, player_id: data.playerId,
        })
      } else if (data.type === "draft_pick") {
        this.pushEventTo(this.el, "depth_chart_place_pick", {
          pos: toPos, idx: toIdx, pick_id: data.pickId,
        })
      }
    })
  }
}
